module.exports = __webpack_public_path__ + "img/site.7c661eef.svg";